module.exports = __webpack_public_path__ + "static/media/arl.ac7641c9.png";